import ProspectProfileRow from "@/shared/components/ui/Avatar/ProspectProfileRow";
import { StatusChip } from "@/shared/components/ui/Status/StatusChip";
import { getTextColorBasedOnValue } from "@/shared/utils/helperFunctions";
import React from "react";

const RelationshipListCard = ({
  contact,
  isSelected,
  onSelect,
  isLastItem = false,
}) => {
  const contactName = contact?.contact_name || "Unknown";
  const designation = contact?.designation || contact?.work_role || "";
  const engagementScore = contact?.engagement_score;

  return (
    <button
      type="button"
      onClick={onSelect}
      className={`flex w-full cursor-pointer gap-3 ${!isLastItem ? "border-b border-gray-200 dark:border-gray-800" : ""} px-4 py-3 text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800/60
        ${isSelected ? "border-l-2 border-l-secondary bg-secondary/10 dark:bg-secondary/20 hover:bg-secondary/15 dark:hover:bg-secondary/25" : ""}`}
    >
      <div className="min-w-0 flex-1">
        <ProspectProfileRow
          name={contactName}
          email={designation}
          avatarUrl=""
          avatarSize="sm"
          number={contact?.engagement_score}
          grayborderColor={true}
        />
        {contact?.title_verified === false ? (
          // pl-10 lines the chip up under the name, past the sm avatar.
          <StatusChip
            label="Unverified"
            withoutBg={true}
            variant="warning"
            className="pl-10 text-[9px] whitespace-nowrap"
          />
        ) : null}
      </div>

      <div className="flex shrink-0 flex-col items-end justify-center gap-0.5">
        <span className="text-[9px] text-gray-500 dark:text-gray-400">
          Engagement
        </span>
        <span
          className={`text-[10px] font-bold ${
            engagementScore != null
              ? getTextColorBasedOnValue(engagementScore)
              : "text-gray-400 dark:text-gray-500"
          }`}
        >
          {engagementScore ?? "N/A"}
        </span>
      </div>
    </button>
  );
};

export default RelationshipListCard;
